import React from 'react';

const Services = () => {
  const services = [
    {
      name: 'Saha Micro',
      description: 'Affordable hatchbacks for daily commute.',
      price: '₹89+',
      image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=600'
    },
    {
      name: 'Saha Prime',
      description: 'Spacious sedans with extra legroom.',
      price: '₹149+',
      image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=600'
    },
    {
      name: 'Saha XL',
      description: 'SUVs for groups and airport trips.',
      price: '₹249+',
      image: 'https://images.unsplash.com/photo-1606016159991-dfe4f2746ad5?w=600'
    },
    {
      name: 'Saha Lux',
      description: 'Premium sedans with professional drivers.',
      price: '₹499+',
      image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7fa0ab8?w=600'
    },
    {
      name: 'Saha Traveller',
      description: '12/15 seater for group outstation.',
      price: '₹899+',
      image: 'https://images.unsplash.com/photo-1590362891991-f776e747a588?w=600'
    },
    {
      name: 'Saha EV',
      description: 'Eco-friendly electric rides.',
      price: '₹129+',
      image: 'https://images.unsplash.com/photo-1542362567-b07e54358753?w=600'
    }
  ];

  const styles = {
    pageHeader: {
      padding: '60px 0 30px',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '60px 24px 30px'
    },
    pageHeaderH1: {
      fontSize: '48px',
      fontWeight: 800,
      marginBottom: '10px'
    },
    serviceGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '30px',
      margin: '50px 0'
    },
    serviceCard: {
      background: '#f7f7f7',
      padding: '30px',
      borderRadius: '24px',
      transition: '0.3s'
    },
    serviceCardHover: {
      transform: 'translateY(-8px)',
      background: '#fff',
      boxShadow: '0 20px 30px rgba(0,0,0,0.1)'
    },
    serviceCardImg: {
      width: '100%',
      borderRadius: '16px',
      marginBottom: '20px',
      height: '200px',
      objectFit: 'cover'
    },
    serviceCardH3: {
      fontSize: '24px',
      marginBottom: '10px'
    },
    btnService: {
      background: '#000000',
      color: 'white',
      border: 'none',
      padding: '12px 25px',
      borderRadius: '50px',
      fontWeight: 600,
      marginTop: '20px',
      cursor: 'pointer',
      width: '100%',
      transition: '0.3s'
    }
  };

  const handleBook = (serviceName) => {
    alert(`Booking ${serviceName} - This will open the booking form`);
  };

  return (
    <main>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageHeaderH1}>Our Rides</h1>
        <p>Choose the perfect ride for your journey.</p>
      </div>
      
      <div className="container" style={styles.serviceGrid}>
        {services.map((service, index) => (
          <div 
            key={index} 
            style={styles.serviceCard}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.boxShadow = '0 20px 30px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = '';
              e.currentTarget.style.background = '#f7f7f7';
              e.currentTarget.style.boxShadow = '';
            }}
          >
            <img src={service.image} alt={service.name} style={styles.serviceCardImg} />
            <h3 style={styles.serviceCardH3}>{service.name}</h3>
            <p>{service.description}</p>
            <p style={{ fontWeight: 'bold', margin: '10px 0' }}>{service.price}</p>
            <button 
              style={styles.btnService}
              onClick={() => handleBook(service.name)}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#d4ed31';
                e.currentTarget.style.color = 'black';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#000000';
                e.currentTarget.style.color = 'white';
              }}
            >
              Book now
            </button>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Services;